<template>
  <div id="planeacion-toolbar-presupuestos">
    <v-toolbar flat>
      <v-toolbar-title class="display-1">
        Presupuestos
      </v-toolbar-title>
    </v-toolbar>
  </div>
</template>

<script>
export default {};
</script>

<style></style>
